import { createSelector } from 'reselect'

const getState = state => state.ArchivedFiles

const getFetchArchivedFilesRequest = state =>
  getState(state).fetchArchivedFilesRequest

const getArchivedFiles = state => getState(state).files

const getArchivedFilesResult = createSelector(
  [getArchivedFiles],
  files => (!files ? [] : files.result)
)

const getArchivedFilesMap = createSelector(
  [getArchivedFiles],
  files => (!files ? {} : files.entities.files)
)

const getArchivedFilesList = createSelector(
  [getArchivedFilesResult, getArchivedFilesMap],
  (result, filesMap) => result.map(id => filesMap[id])
)

const getArchivedFile = (state, id) => getArchivedFilesMap(state)[id]

export {
  getArchivedFiles,
  getArchivedFilesList,
  getFetchArchivedFilesRequest,
  getArchivedFile
}
